export function createNotificationToggle({ btn }) {
  if (!btn) return;

  const dot = btn.querySelector('.notif-dot');

  function setActive(enabled) {
    btn.setAttribute('aria-pressed', String(enabled));
    btn.classList.toggle('dash-notif-btn--active', enabled);
    if (dot) dot.hidden = !enabled;
    btn.title = enabled ? 'Notifications email activées — cliquer pour désactiver' : 'Notifications email désactivées — cliquer pour activer';
  }

  async function fetchSettings() {
    try {
      const res = await fetch('/api/notifications');
      const data = await res.json();
      setActive(Boolean(data.enabled));
    } catch {
      // silently ignore if server unreachable
    }
  }

  async function toggle() {
    const current = btn.getAttribute('aria-pressed') === 'true';
    const next = !current;
    setActive(next);
    try {
      const res = await fetch('/api/notifications', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ enabled: next }),
      });
      const data = await res.json();
      setActive(Boolean(data.enabled));
    } catch {
      setActive(current);
    }
  }

  btn.addEventListener('click', toggle);
  fetchSettings();
}
